const KenapaCoding: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🚀 Kenapa Anak Muda Harus Ikut Lomba Coding?</h2>
            <p className="mb-4">
                Ikut lomba coding bukan cuma buat yang udah jago ngoding. Justru, ini adalah kesempatan emas buat anak muda yang ingin tumbuh dan bersaing di dunia teknologi. Berikut alasan kenapa kamu harus coba terjun ke kompetisi coding 👇
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>
                    <strong>🧠 Melatih problem solving dan logika</strong>
                    <p>Lomba coding mengasah kemampuan berpikir kritis dan menyelesaikan masalah secara sistematis. Bukan sekadar ngoding, tapi juga melatih otakmu berpikir cepat dan efisien!</p>
                </li>
                <li>
                    <strong>🏅 Menambah portofolio dan prestasi</strong>
                    <p>Sertifikat dan penghargaan dari lomba bisa jadi nilai tambah besar di CV atau LinkedIn kamu. Bahkan partisipasi saja sudah menunjukkan kamu aktif dan mau berkembang!</p>
                </li>
                <li>
                    <strong>🌐 Memperluas relasi dan komunitas</strong>
                    <p>Lomba sering jadi tempat berkumpulnya para coder muda dari berbagai daerah. Kamu bisa kenalan, diskusi, bahkan kolaborasi di proyek bareng setelah lomba.</p>
                </li>
                <li>
                    <strong>💼 Jadi batu loncatan ke karier teknologi</strong>
                    <p>Banyak perusahaan teknologi suka banget sama kandidat yang aktif ikut kompetisi. Bahkan gak jarang peserta lomba direkrut langsung karena potensinya!</p>
                </li>
            </ul>

            <p className="text-gray-700">
                Jadi, jangan ragu buat mulai ikut lomba coding. Menang itu bonus, tapi pengalaman dan pelajaran yang kamu dapat itu priceless. Ayo tunjukkan potensimu! ✨
            </p>
        </div>
    )
}
export default KenapaCoding